import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { HRListType } from './type'

export interface IHRListState {
  isOpen: boolean
  HRList: HRListType[]
  mappedItem: any,
  backgroundIndexingJobs: { [documentId: string]: string } // documentId to jobId mapping
}

export const initialState: IHRListState = {
  isOpen: false,
  HRList: [],
  mappedItem: { sourceColumns: [], targetColumns: [] },
  backgroundIndexingJobs: {},
}

const HRListSlice = createSlice({
  name: 'HRList',
  initialState,
  reducers: {
    addHRDocument(state: IHRListState, action: PayloadAction<any>) {
      const newDocument = action.payload
      const document = state.HRList.find((doc: any) => doc.id === newDocument.id)
      if (newDocument.id !== null && !document) {
        state.HRList.push(newDocument)
      }
      else if (document) {
        document.isActive = newDocument.isActive
        document.documentStatus = newDocument.documentStatus
      }
    },
    updateHRDocument(state: IHRListState, action: PayloadAction<any>) {
      const { id, status } = action.payload
      const document = state.HRList.find((doc: any) => doc.id === id)
      if (document) {
        document.status = status
      }
    },
    updateHRDocumentStatus(state: IHRListState, action: PayloadAction<any>) {
      const { id, isActive } = action.payload
      if (state.HRList[id]) {
        state.HRList[id].isActive = isActive
      }
    },
    updateHRMappedStatus(state: IHRListState, action: PayloadAction<any>) {
      const { documentId, isMapped } = action.payload
      const document = state.HRList.find((doc: any) => doc.id === documentId)
      if (document) {
        document.mappingCompleted = isMapped
      }
    },
    updateAllHRDocumentStatus(state: IHRListState, action: PayloadAction<any>) {
      state.HRList = action.payload
    },
    addHRDocumentMapping(state: any, action: PayloadAction<any>) {
      state.mappedItem = {
        ...action.payload,
        targetColumns: action.payload.targetColumns.map((targetItem: any) => {
          const position = action.payload.sourceColumns
            .map((sourceItem: any) => sourceItem.mappedTargetColumnId)
            .indexOf(targetItem.id)
          if (position !== -1) {
            return {
              ...targetItem,
              mappedTargetColumnId: action.payload.sourceColumns[position].id,
            }
          }
          return targetItem
        }),
      }
    },
    updateHRDocumentMapping(state: any, action: PayloadAction<any>) {
      const { sourceColumnId, targetColumnId } = action.payload
      const sourceColumns = state.mappedItem.sourceColumns.find(
        (item: any) => item.id === sourceColumnId,
      )
      if (sourceColumns) {
        sourceColumns.mappedTargetColumnId = targetColumnId
      }
      const targetColumns = state.mappedItem.targetColumns.find(
        (item: any) => item.id === targetColumnId,
      )
      if (targetColumns) {
        targetColumns.mappedTargetColumnId = sourceColumnId
      }
    },
    removeHRDocumentMapping(state: any, action: PayloadAction<any>) {
      const { targetColumnId } = action.payload
      if (targetColumnId) {
        state.mappedItem.sourceColumns = state.mappedItem.sourceColumns.map(
          (item: any) => {
            if (item.mappedTargetColumnId === targetColumnId) {
              item.mappedTargetColumnId = null
            }
            return item
          },
        )
        state.mappedItem.targetColumns = state.mappedItem.targetColumns.map(
          (item: any) => {
            if (item.id === targetColumnId) {
              item.mappedTargetColumnId = null
            }
            return item
          }
        )
      }
    },
    removeSourceHRDocumentMapping(state: any, action: PayloadAction<any>) {
      const { sourceColumnId } = action.payload
      if (sourceColumnId) {
        state.mappedItem.sourceColumns = state.mappedItem.sourceColumns.map(
          (item: any) => {
            if (item.id === sourceColumnId) {
              item.mappedTargetColumnId = null
            }
            return item
          },
        )
        state.mappedItem.targetColumns = state.mappedItem.targetColumns.map(
          (item: any) => {
            if (item.mappedTargetColumnId === sourceColumnId) {
              item.mappedTargetColumnId = null
            }
            return item
          }
        )
      }
    },
    setBackgroundIndexingJobs(state: any, action: PayloadAction<any>) {
      const { documentId, jobId } = action.payload
      state.backgroundIndexingJobs[documentId] = jobId
    }
  },
})

export const {
  addHRDocument,
  updateHRDocument,
  updateHRDocumentStatus,
  updateAllHRDocumentStatus,
  addHRDocumentMapping,
  updateHRDocumentMapping,
  removeHRDocumentMapping,
  removeSourceHRDocumentMapping,
  updateHRMappedStatus,
  setBackgroundIndexingJobs
} = HRListSlice.actions
export default HRListSlice.reducer
